import { render, staticRenderFns } from "./allMenusNew.vue?vue&type=template&id=51202c30&scoped=true"
import script from "./allMenusNew.vue?vue&type=script&lang=js"
export * from "./allMenusNew.vue?vue&type=script&lang=js"
import style0 from "./allMenusNew.vue?vue&type=style&index=0&id=51202c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51202c30",
  null
  
)

export default component.exports